/* eslint-disable import/first */
import React, { Component } from "react";
import { Route, withRouter } from "react-router-dom";
import * as config from "config/config";

class DeleteDemande extends Component {
	constructor() {
		super();
	}
	componentDidMount() {
		config
			.apiFetch(config.Api_Url + "/delete/GroupementColis", {
				method: "POST",
				body: JSON.stringify({
					groupement_id: this.props.match.params.groupement_id,
				}),
				headers: { "Content-Type": "application/json" },
			})
			.then((response) => response.json())
			.then((data) => {
				if (data["data"].affectedRows != 0) {
					this.props.history.goBack();
				} else {
					this.props.history.push("/404");
				}
			});
	}
	render() {
		return null;
	}
}

export default withRouter(DeleteDemande);
